import { BaseEvent } from '@kiplin/web-common/event';

export type GameCreationModalOpenRequestedEventData = never;

export class GameCreationModalOpenRequestedEvent extends BaseEvent<GameCreationModalOpenRequestedEventData> {
  public static override getKey(): string {
    return 'game-creation-modal-open-requested';
  }

  public constructor(init: CustomEventInit<GameCreationModalOpenRequestedEventData>) {
    super(GameCreationModalOpenRequestedEvent.getKey(), init);
  }
}
